var path = 'modules/dcb-eaccount.pages.eadashboard/components/actualBalance.tpl.html';
var html = "<div ng-controller=\"ActualBalanceController as controller\">\n<div class=\"portlet-body\" ng-class=\"{loading : controller.loading}\" >\n    <dc-spinner></dc-spinner>\n    <h3 class=\"plain-heading\"><small data-i18n=\"modules.dashboard.actualbalance\"></small><br>\n        {{controller.value.amount | money}}</h3>\n    </div>\n</div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./~/ngtemplate-loader?relativeTo=/src/ui/modules/eaDashboard/components&prefix=modules/dcb-eaccount.pages.eadashboard/components!./~/raw-loader!./src/ui/modules/eaDashboard/components/actualBalance.tpl.html
// module id = 884
// module chunks = 12